<template>

  <!-- Product Schema By Schema.org -->
  <teleport to="head">
    <component :is="'script'" type="application/ld+json" v-text="productSchema">
    </component>
  </teleport>

  <section id="product_details" class=""  ref="productDetailsRef">
    <div class="bg-white lg:px-28">
      <div class="pt-0">
        <div
          class="max-w-2xl mx-auto pt-10 px-4 sm:px-6 lg:px-0 lg:max-w-7xl lg:pt-12 lg:grid lg:grid-cols-4 lg:grid-rows-[auto,auto,1fr] lg:gap-x-8">

          <!-- start Image gallery -->
          <div
            class="lg:col-span-2 flex flex-col justify-center items-center h-[636px] border border-[#E2E2E2] rounded-lg"
            v-if="productInfo && !isLoading && productInfo?.images?.length > 0">
            <swiper :style="{ '--swiper-navigation-color': '#fff', '--swiper-pagination-color': '#fff' }"
              :spaceBetween="10" :navigation="true" :thumbs="{ swiper: thumbsSwiper }" class="mySwiper2  ">
              <swiper-slide v-for="image in productInfo?.images" :key="image.url">
                <img v-if="image.url" :src="image.url" class="rounded-2xl w-full object-contain" />
                <img src="../../assets/images/placeholder-image.svg" v-else alt="" class="rounded-2xl w-full object-contain" />
              </swiper-slide>
            </swiper>
            <swiper @swiper="setThumbsSwiper" :spaceBetween="10" :slidesPerView="3" :freeMode="true"
              :watchSlidesVisibility="true" :watchSlidesProgress="true" class="mySwiper">
              <swiper-slide v-for="image in productInfo?.images" :key="image.url"
                class="!rounded-lg m-0 mx-auto !w-24 !h-24 !lg:max-w-sm !lg:max-h-sm !lg:min-w-sm !lg:min-h-sm">
                <img v-if="image.url" :src="image.url" class="!rounded-lg w-full h-full object-contain" />
                <img src="../../assets/images/placeholder-image.svg" v-else alt="" class="!rounded-lg w-full h-full object-contain" />
              </swiper-slide>
            </swiper>
          </div>
          <div class="lg:col-span-2 lg:sticky lg:top-10 " v-if="productInfo && !isLoading && productInfo?.image">
            <swiper :style="{ '--swiper-navigation-color': '#fff', '--swiper-pagination-color': '#fff' }"
              :navigation="false" :allowTouchMove="false" class="mySwiper2 border border-[#E2E2E2] rounded-lg ">
              <swiper-slide>
                <img v-if="productInfo?.image" :src="productInfo?.image"
                  class="rounded-2xl w-[442px] h-[400px] max-h-[400px] object-contain" />
                <img src="../../assets/images/placeholder-image.svg" v-else alt=""
                  class="rounded-2xl w-[442px] h-[400px] max-h-[400px] object-contain" />
              </swiper-slide>
            </swiper>
          </div>
          <!-- Image gallery Skeleton-->
          <div class="lg:col-span-2 lg:sticky lg:top-10 " v-if="!productInfo && isLoading">
            <swiper :style="{ '--swiper-navigation-color': '#fff', '--swiper-pagination-color': '#fff' }"
              :navigation="false" :allowTouchMove="false" class="mySwiper2 border border-[#E2E2E2] rounded-lg ">
              <swiper-slide>
                  <div class="skeleton-box rounded-2xl w-[442px] h-[400px] max-h-[400px]"></div>
              </swiper-slide>
            </swiper>
          </div>
          <!-- End Image gallery -->

          <!-- start Product info -->
          <div v-if="productInfo && !isLoading " class="md:mt-4 mt-8 lg:mt-0 lg:row-span-3 lg:col-span-2">
            <div class="flex justify-between items-start">
              <h1 class="text-2xl font-bold tracking-tight text-dark-4 sm:tracking-tight sm:text-2xl w-[90%]">
                {{ productInfo?.title}} 
                <span class="ms-3 text-base text-dark-2/70 uppercase" v-if="productInfo?.unit && productInfo?.factor"> 
                  {{ $filters.RTLNumbers( 
                    isUnitHasBrackets(productInfo?.unit)? 
                    productInfo?.unit : 
                    "( "+productInfo?.unit+" )") }}
                </span>
              </h1>
              <button v-if="isLoggedIn"
                class="bg-[#EEEEEE] product-card-vertical_favorite hover:shadow-md transition shadow-[#9E9E9E3D] rounded-xl p-2 "
                @click="addToWishListRequest(productInfo)">
                <img
                  :src="productInfo?.is_wishlisted ? require('@/assets/icons/ic-heart-fill.svg') : require('@/assets/icons/ic-heart.svg')"
                  alt="add to favorites " />
              </button>
            </div>
            <div class="space-y-6 mt-2" v-if="productInfo?.brand">
                <p class="text-base text-dark-2/70 uppercase ">{{ productInfo?.brand }}</p>
            </div>

            <router-link as="div" v-if="productInfo?.category && productInfo?.subcategory" :to="{
              name: 'category',
              params: {
                CatSlug: productInfo?.category.slug,
                subCatSlug: productInfo?.subcategory.slug
              }
            }"
              class=" mt-3 inline-block transition-all text-dark-2 mb-8 border rounded px-4 py-2 border-primary hover:bg-primary">
              <span class="">{{ productInfo?.subcategory.title }}</span>
            </router-link>

            <!-- product is not available note  -->
            <div v-if="productInfo?.quantity == 0" class="mt-8">
              <p class="text-red font-bold ">{{ t('pages.product_details.Product_Isnt_Available') }}</p>
              <p class="text-dark-4 mt-3">{{ t('pages.product_details.we_can_notify') }}</p>
            </div>

            <!-- Description and details -->
            <div class="mt-8">
              <div class="space-y-6">
                <p class="text-base text-dark-4">{{ productInfo?.description }}</p>
              </div>
            </div>

            <!-- Shipping -->
            <!-- <div>
              <h2 class="my-8 text-lg font-bold text-dark-4">{{t('pages.product_details.Delivery')}}</h2>

              <div class="  flex  items-center justify-start">
                <div
                  class="_img w-12 h-12 my-1.5 me-6 rounded-lg border-[#FFCD00] border-2 grid justify-center items-center">
                  <img src="../../assets/icons/ic-delivery.svg" alt="" class="w-auto h-auto" />
                </div>
                <div class="">
                  <p class=" font-bold">{{t('pages.product_details.Free_Shipping')}}</p>
                  <p class=" text-sm text-dark-gray-3">{{t('pages.product_details.On_Order_Of')}}</p>
                </div>
              </div>

              <p class="mt-4"> {{t('pages.product_details.delivery_expected_days')}} </p>
            </div> -->
            <!-- Frequently Bought Together --> 
            <!-- <div class="mb-16">
              <h2 class="my-8 text-lg font-medium text-dark-4"> {{t('pages.product_details.Frequently_Bought_Together')}}</h2>
              <div class="frequently-products flex items-center flex-wrap  ">
                <div v-for="(frequently_product, index) in frequentlyProducts" :key="frequently_product.id">
                  <router-link v-if="frequently_product?.id" :to="{
                    name: 'product',
                    params: { productSlug: frequently_product?.slug }
                  }" class=" flex flex-col items-start justify-start w-auto "
                    :class="{ 'lg:border-e lg:pe-6': index == (frequentlyProducts?.length - 1) }">

                    <div class="flex items-center justify-between ">
                      <div class=" mb-2  rounded-lg max-w-[3.5rem] max-h-[3.5rem]  w-14 h-14">
                        <img v-if="frequently_product.image" :src="frequently_product.image"
                          :alt="frequently_product.title" class="w-full h-full rounded-lg object-contain" />
                        <img src="../../assets/images/placeholder-image.svg" v-else alt="" class="w-full h-full rounded-lg object-contain" />
                      </div>
                      <font-awesome-icon icon="plus" class="text-lg  mx-6"
                        v-if="index < (frequentlyProducts?.length - 1)" />
                    </div>

                    <div class="">
                      <p class=" font-bold text-sm text-center flex-wrap max-w-[3.5rem] line-clamp-2">{{
                          frequently_product.title
                      }}</p>
                    </div>
                  </router-link>
                </div>

                <div class=" hidden lg:flex flex-col w-full mt-4 h-full lg:w-auto lg:mt-0 lg:ps-6">
                  <p class="text-sm">{{t('pages.product_details.Total_Price')}} <span class="font-bold">{{ $filters.RTLNumbers(totalFrequentlyProductsPrice) }}</span>
                    <span class="text-xs"> {{t('currency.EGP')}}</span>
                  </p>
                  <secondary-button @click="addFrequentlyProductsToCart(frequentlyProducts)"
                    class="flex justify-between items-center py-2 add-btn mt-2">
                    <a href="#" class="group me-2  flex items-center" data-v-f7c795a4=""><svg
                        xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                        stroke="currentColor" aria-hidden="true"
                        class="flex-shrink-0 h-6 w-6 white group-hover:text-white" data-v-f7c795a4="">
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"></path>
                      </svg></a>
                    <p class="">{{t('buttons.Add_All_To_Cart')}}</p>
                  </secondary-button>
                </div>
              </div>
              <div class=" lg:hidden flex flex-col lg:w-full mt-6 h-full  lg:mt-0 lg:ps-6">
                <p class="text-sm ">
                {{t('pages.product_details.Total_Price')}} <span class="font-bold">{{  $filters.RTLNumbers(totalFrequentlyProductsPrice) }}</span> 
                <span class="text-xs">{{t('currency.EGP')}}</span>
                </p>
                <secondary-button @click="addFrequentlyProductsToCart(frequentlyProducts)"
                  class="add-btn flex justify-center items-center py-2 w-1/2 mt-2">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                    stroke="currentColor" aria-hidden="true" class="flex-shrink-0 h-6 w-6 white group-hover:text-white"
                    data-v-f7c795a4="">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z">
                    </path>
                  </svg>
                  <p class="ms-5 lg:ms-auto">{{t('buttons.Add_All_To_Cart')}}</p>
                </secondary-button>
              </div>
            </div> -->

            <!-- Product Price -->
            <div class="flex flex-start items-center space-s-4 mb-4">
              <span class="text-lg text-dark-gray-1">{{ productInfo?.discounted_price!= '0' ?   $filters.RTLNumbers(productInfo?.discounted_price)  : $filters.RTLNumbers(productInfo?.price) }} {{t('currency.EGP')}}</span>
              <span class="text-sm text-dark-gray-6 line-through" v-if="productInfo?.discounted_price != '0'">{{ $filters.RTLNumbers(productInfo?.price) }} {{t('currency.EGP')}}</span>
              <span class="text-sm text-dark-gray-6" v-if="productInfo?.discounted_label">{{$filters.RTLNumbers(productInfo?.discounted_label)}} {{ t('general.Off') }} </span>
            </div>

            <!-- Choose Quantity and Add to cart -->
            <div v-if="productInfo?.quantity != 0 && orderQuantity >= 0" class="flex justify-start items-center">
              <primary-button class="add-btn flex justify-start justify-center items-center space-s-2 w-3/5"
                @click="addToCart(productInfo)" :disabled="orderQuantity == 0"
                :class="{ 'grayscale !text-dark-gray-7 !bg-light-gray-9 hover:bg-light-gray-9 hover:text-dark-gray-7': orderQuantity == 0 }">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                  stroke="currentColor" aria-hidden="true" class="flex-shrink-0 h-6 w-6 white group-hover:text-white"
                  data-v-f7c795a4="">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z">
                  </path>
                </svg>
                <p>{{t('buttons.Add_to_Cart')}}</p>
              </primary-button>

              <div class="flex ms-auto  lg:ms-auto items-center">
                <button class=" rounded-lg focus:outline-none disabled:opacity-50" @click="decreaseOrderQuantity"
                  :disabled="(orderQuantity == 1)">
                  <font-awesome-icon icon="minus" class="text-lg rounded-lg border border-dark-4 p-3 " />
                </button>
                <input type="text" id="quantity" v-model="orderQuantity" v-numberOnly autocomplete="off"
                  class="border-0 w-7 h-5 p-0 mx-3 focus:ring-0 text-center" />
                <button @click="increaseOrderQuantity" :disabled="(orderQuantity >= productInfo?.quantity)"
                  class=" rounded-lg  focus:outline-none disabled:opacity-50">
                  <font-awesome-icon icon="plus" class="text-lg rounded-lg border border-dark-4 p-3 " />
                </button>
              </div>
            </div>
            <!-- Notify client -->
            <div v-if="productInfo?.quantity == 0" class="flex justify-start items-center">
              <secondary-button class="add-btn flex justify-start justify-center items-center space-s-2 w-3/5"
                @click="notifyMe()" :disabled="productInfo?.is_notified"
                :class="{ 'grayscale !text-dark-gray-7 !bg-light-gray-9 hover:bg-light-gray-9 hover:text-dark-gray-7': productInfo?.is_notified }">
                <p> {{ productInfo?.is_notified ? t('buttons.Notified') : t('buttons.Notify_Me') }}
                </p>
              </secondary-button>
            </div>
          </div>
          <!-- End Product info -->

          <!-- start Product info skeleton -->
          <div v-if="!productInfo && isLoading " class="md:mt-4 mt-8 lg:mt-0 lg:row-span-3 lg:col-span-2">
            <div class="flex justify-between items-start">
              <h1 class="w-[215px] skeleton-box h-[15px]"></h1>
              <div v-if="isLoggedIn"
                class="skeleton-box  w-10 h-10  bg-[#EEEEEE] product-card-vertical_favorite transition shadow-[#9E9E9E3D] rounded-xl"
             >
              </div>
            </div>
            <div class="space-y-6 mt-2 skeleton-box h-[15px] w-[160px]">
            </div>
            <div  class=" mt-3 inline-block transition-all text-dark-2 mb-8 border rounded px-4 py-2 skeleton-box w-16 h-10">
            </div>


            <!-- Description and details -->
            <div class="mt-8">
              <div class="space-y-6">
                <p class="text-base text-dark-4 skeleton-box h-[15px] w-full"></p>
                <p class="text-base text-dark-4 skeleton-box h-[15px] w-full"></p>
                <p class="text-base text-dark-4 skeleton-box h-[15px] w-[160px]"></p>
              </div>
            </div>

            <!-- Shipping -->
            <!-- <div>
              <h2 class="my-8 text-lg font-bold text-dark-4 skeleton-box h-[15px] w-[100px]"></h2>

              <div class="  flex  items-center justify-start">
                <div class="_img skeleton-box w-12 h-12 my-1.5 me-6 rounded-lg   grid justify-center items-center">
                </div>
                <div class="">
                  <p class="skeleton-box h-[15px] w-[104px]"></p>
                  <p class="skeleton-box h-[15px] w-[130px] mt-2"></p>
                </div>
              </div>

              <p class="skeleton-box h-[15px] w-[400px] mt-4"></p>
            </div> -->
            <!-- Frequently Bought Together --> 
            <!-- <div class="mb-16">
              <h2 class="my-8 skeleton-box h-[15px] w-[222px]"></h2>
              <div class="frequently-products flex items-center flex-wrap  ">
                <div v-for="(frequently_product, index) in ['','','']" :key="frequently_product.id">
                  <div class=" flex flex-col items-start justify-start w-auto "
                  :class="{ 'lg:border-e lg:pe-6': index == 2 }">

                    <div class="flex items-center justify-between ">
                      <div class=" mb-2  rounded-lg max-w-[3.5rem] max-h-[3.5rem]  w-14 h-14"
                      >
                        <div class="skeleton-box w-full h-full rounded-lg" ></div>
                      </div>
                      <font-awesome-icon icon="plus" class="text-lg  mx-6"
                        v-if="index <= 1" />
                    </div>

                    <p class=" skeleton-box h-[15px] w-[50px] flex-wrap max-w-[3.5rem] "></p>
                  </div>
                </div>

                <div class=" hidden lg:flex flex-col w-full mt-4 h-full lg:w-auto lg:mt-0 lg:ps-6">
                  <p class="skeleton-box h-[15px] w-[146px] "></p>
                  <div class="skeleton-box w-[141px] h-10 mt-2"></div>
                </div>
              </div>
              <div class=" lg:hidden flex flex-col lg:w-full mt-6 h-full  lg:mt-0 lg:ps-6">
                <p class="skeleton-box h-[15px] w-[146px] "></p>
                <div class="skeleton-box w-[141px] h-10 mt-2"></div>
              </div>
            </div> -->

            <!-- Product Price -->
            <div class="flex flex-start items-center space-s-4 mb-4">
              <span class="skeleton-box h-[15px] w-[84px]"></span>
              <span class="skeleton-box h-[15px] w-[42px]"></span>
              <span class="skeleton-box h-[15px] w-[49px]"></span>
            </div>
          </div>
          <!-- End Product info skeleton -->

        </div>
      </div>
    </div>

    <!-- start related products section -->
    <section v-if="relatedProducts?.length > 0" id="related_products" class=" mx-auto px-6 lg:px-28 clear-both mb-28 mt-24">
      <section-heading>
        <template v-slot:subTitle> {{t('pages.product_details.PRODUCTS')}}</template>
        <template v-slot:title> {{t('pages.product_details.related_products_subtitle')}}</template>
      </section-heading>
      <products-slider :content="relatedProducts" class="mt-12 " />
    </section>
    <featuredProductsSkeleton v-if="!relatedProducts  && isLoading" :showHeader="true" :headerPosition="'left'" class="mb-28 mt-24"/>
    <!-- End related products section -->

  </section>
  <!-- loader -->
  <!-- <Loader :modalIsOpen="isLoading" :initFocusedRef="productDetailsRef" class="" :widthSM="true"></Loader> -->

</template>
<script>
import { ref, onBeforeMount, computed, watch, nextTick } from "vue"
import { useRoute, useRouter } from "vue-router"
import { useI18n } from "vue-i18n";
import { useStore } from 'vuex'
import Response from "@/common/Response"
import Request from "@/common/Request"
import Routes from '@/common/Routes'
import Product from "@/models/Product"
import Cart from "@/models/Cart"
import { numberOnly } from '@/common/Directives/numberOnly';


import SecondaryButton from "@/components/atoms/buttons/SecondaryButton"
import PrimaryButton from "@/components/atoms/buttons/PrimaryButton"
import SectionHeading from "@/components/atoms/headings/SectionHeading.vue";
import ProductsSlider from "@/components/organisms/ProductsSlider";
import Loader from "@/components/atoms/Loader";
import featuredProductsSkeleton from "@/components/skeletons/featuredProductsSkeleton.vue";

// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue';

// Import Swiper styles
import 'swiper/swiper.scss';
// import "swiper/components/navigation/navigation.min.css"
import "swiper/components/thumbs/thumbs.min.css"
import "swiper/swiper-bundle.min.css"

import SwiperCore, {
  Navigation, Thumbs
} from 'swiper/core';

// install Swiper modules
SwiperCore.use([Navigation, Thumbs]);

export default ({
  name: 'product-details',
  directives: {
    'numberOnly': numberOnly
  },
  components: {
    Swiper, SwiperSlide,
    SecondaryButton, PrimaryButton,
    SectionHeading, ProductsSlider,
    Loader,
    featuredProductsSkeleton
  },

  setup() {
    const route = useRoute()
    const router = useRouter()
    const { t } = useI18n();

    const store = useStore()
    const isLoading = ref(false)
    const productDetailsRef = ref()
    const isLoggedIn = computed(() => { return store.getters.isLoggedIn })

    const productSlug = route.params.productSlug
    const productInfo = ref(null)
    const frequentlyProducts = ref([{}])
    const totalFrequentlyProductsPrice = computed(() => frequentlyProducts.value.reduce((acc = {}, item = {}) => {
      const itemTotal = parseFloat(item.price);
      acc.total = acc.total + itemTotal
      return acc;
    }, { total: 0 }).total
    )

    const isUnitHasBrackets = function (unitValue) {
      return unitValue.indexOf('(') == -1 ? false : true
    }

    const relatedProducts = ref(null)

    //add to cart
    const orderQuantity = ref(store.getters.cartProducts?.filter((product)=> productInfo?.id == product.id)[0]?.quantity || 1 )
    const increaseOrderQuantity = function () {
      orderQuantity.value = parseInt(orderQuantity.value) + 1
    }
    const decreaseOrderQuantity = function () {
      if (orderQuantity.value > 0) {
        orderQuantity.value = parseInt(orderQuantity.value) - 1
      }
    }

    const getProductDetails = (async (currentProdId) => {
      await new Product().getProductDetails(currentProdId).then((response) => {
        productInfo.value = response.data?.data?.product
        productSchema.value = {
          "@context": "https://schema.org",
          "@type": "Product",
          "productID": productInfo.value?.id,
          "name": productInfo.value?.title,
          "image": productInfo.value?.image,
          "brand": productInfo.value?.brand,
          "description": productInfo.value?.description,
          "image":productInfo.value?.image,
          "category":productInfo.value?.category.title,
          "offers": {
            "@type": "Offer",
            "availability": "https://schema.org/InStock",
            "price": productInfo.value?.price,
            "priceCurrency": "EGP",
            "seller":"RDNA"
          },
        }
        frequentlyProducts.value = response.data.data.frequentlyBoughtTogether
        relatedProducts.value = response.data.data.relatedProducts
        //add product image to gallery
        if (productInfo.value?.images?.length > 0) {
          productInfo.value.images = [{ url: productInfo.value?.image }, ...productInfo.value?.images]
        }
        //set requested product quantity
        orderQuantity.value =  (store.getters.cartProducts.filter((product)=> product.id == currentProdId)[0]?.quantity) || 1
        isLoading.value = false
      }).catch((err) => {
        isLoading.value = false
      }).then(async() => {
        //broken images 
        await nextTick()
        setDefaultImage() 
        isLoading.value = false
      });
    })

    // notify client when product out of stock
    const notifyMe = function () {
      isLoading.value = true
      new Request().get(`product/notify/${productSlug}`).then((res) => {
        isLoading.value = false
        if (res) {
          if (store.getters.userArea) {
            new Response({ message: t('messages.notify_me_msg') }).displaySuccess()
          } else {
            store.commit('selectAreaModal', true)
          }
        }
      }).catch((err) => {
        isLoading.value = false
      })
    }

    //add to wishlist 
    const addToWishListRequest = function (product) {
      let payload = {
        product_id: product.id,
      }
      new Product().addToWishlist(payload).then((response) => {
        if (response?.data) {
          isLoading.value = false

          //display success toaster
          new Response({ message: ` ${productInfo.value?.is_wishlisted ? t('messages.removed_from_wishlist') : t('messages.added_to_wishlist')}` }).displaySuccess()
          //set new wishlist status
          productInfo.value.is_wishlisted = !productInfo.value?.is_wishlisted
        } else {
          isLoading.value = false
        }

      }).catch((err) => {
        isLoading.value = false
      }).then(() => {
        isLoading.value = false
      });
    }

    //set default image if image from server has error
    const setDefaultImage = function () {
			let images = Array.from(document.getElementsByTagName('img'))
			images.forEach(image => {
				image.addEventListener("error", function () {
					image.error = null
					image.removeAttribute('src');
					image.setAttribute('src', require('@/assets/images/placeholder-image.svg'));
          image.classList.add('!object-none')
				});
			});
		}

    //swiper
    let thumbsSwiper = ref(null);

    watch(
      () => route.params.productSlug,
      async newProdId => {
        if (newProdId) {
          isLoading.value = true
          //set current page value for pagination
          getProductDetails(newProdId)
        }
      }
    )

    //product schema 
    const productSchema = ref({
    "@context": "https://schema.org",
    "@type": "Product",
    "productID": productInfo.value?.id,
    "name": productInfo.value?.title,
    "image": productInfo.value?.image,
    "brand":productInfo.value?.brand,
    "description":productInfo.value?.description,
    "image":productInfo.value?.image,
    "category":productInfo.value?.category.title,
    "offers": {
        "@type": "Offer",
        "availability": "https://schema.org/InStock",
        "price": productInfo.value?.price,
        "priceCurrency": "EGP",
        "seller":"RDNA"
    },
})
    onBeforeMount(async () => {
      isLoading.value = true
      // get single product data
      getProductDetails(productSlug)
    })


    return {
      t,
      productDetailsRef,
      productSchema,
      isLoading,
      isLoggedIn,
      productInfo,
      productSlug,
      frequentlyProducts,
      totalFrequentlyProductsPrice,
      relatedProducts,
      isUnitHasBrackets,
      //add to wishlist
      addToWishListRequest,
      //add to cart
      orderQuantity,
      increaseOrderQuantity,
      decreaseOrderQuantity,
      addToCart(product) {
        if (store.getters.userArea) {
          isLoading.value = true
          let payload = [{
            product_id: product.id,
            quantity: orderQuantity.value
          }]
          new Cart().addToCart(payload).then((response) => {

            //update local storage and cart store
            const cartOrder = response.data.data
            store.dispatch("updateCartOrder", cartOrder)
            localStorage.setItem('cart_order', JSON.stringify(cartOrder));
            isLoading.value = false
            //display success toaster
            new Response({ message: t('messages.Product_Added_Successfully') }).displaySuccess()
          }).catch((err) => {
            isLoading.value = false
          });
        } else {
          store.commit('selectAreaModal', true)
        }
      },
      addFrequentlyProductsToCart(frequentlyProducts) {
        if (store.getters.userArea) {
          isLoading.value = true
          let payload = []
          frequentlyProducts.forEach(product => {
            payload.push({
              "product_id": product.id,
              "quantity": 1
            })
          });

          new Cart().addToCart(payload).then((response) => {
            //update local storage and cart store
            const cartOrder = response.data.data
            store.dispatch("updateCartOrder", cartOrder)
            localStorage.setItem('cart_order', JSON.stringify(cartOrder));
            isLoading.value = false
            //display success toaster
            new Response({ message: t('messages.Frequently_Products_Added_Successfully') }).displaySuccess()
          }).catch((err) => {
            isLoading.value = false
          });
        } else {
          store.commit('selectAreaModal', true)
        }
      },
      //notify client
      notifyMe,
			//image error
			setDefaultImage,
      //swiper
      setThumbsSwiper(swiper) {
        thumbsSwiper.value = swiper;
      },
      thumbsSwiper,
    }
  },
})
</script>
<style scoped lang="scss">
#product_details {
  .add-btn {
    p {
      line-height: 1.5;
    }
  }

  //main swiper 
  .swiper-container {
    @apply w-full h-full mx-auto pb-3;
  }

  .mySwiper2 {
    @apply w-full h-full;

    .swiper-slide {
      @apply lg:p-14 px-8 py-8;

      img {
        @apply h-full;
      }
    }
  }

  // thumbs swiper
  .mySwiper {
    @apply mt-4 h-[20%] box-border;

    :deep(.swiper-wrapper) {
      @apply flex justify-between w-[80%]
    }

    .swiper-slide {
      @apply bg-cover bg-center w-1/4 h-full opacity-40 m-0;

      img {
        @apply w-full h-full object-contain block;
      }
    }

    .swiper-slide-thumb-active {
      @apply border-2 border-primary opacity-100;
    }

  }

  // swiper navigations
  :deep(.swiper-button-next) {
    @apply w-6 h-6 rtl:left-[5px] rtl:lg:left-[3%]  ltr:right-[5px] ltr:lg:right-[3%];
  }


  :deep(.swiper-button-prev) {
    @apply w-6 h-6 left-[5px] lg:left-[3%];
  }

  :deep(.swiper-button-next::after),
  :deep(.swiper-button-prev::after) {
    @apply text-sm text-black font-bold opacity-100;
  }
}
</style>
